export const apiUrl = 'https://dev-api.diveaaus.org';
export const uploadsUrl = 'https://dev-uploads.diveaaus.org';
export const siteUrl = 'http://localhost:3000';
export const itemsPerPage = 20;
export const divelb = 2195;
